export default function Go_Tools() {
  return (
    <div>
      <h1>Go_Tools </h1>
      <p>Go Tools</p>
    </div>
  );
}
